import { codeApp, domainSaludApp } from "@interfaces/organizationI";
import { environment } from "../environments/environment";

export function getSubdomainByLocation (app?: "operational" | "saludProx" | "reports") : string {
    let finData: domainSaludApp = "saludProx";
    const hostname = window.location.hostname;  
    const hostnameSplited = hostname.split(".");
    if (hostnameSplited.length > 0) {
        switch (hostnameSplited[0]) {
            case "drgyc":
            case "gyc":
                    finData = "gyc";
                break;
            case "drmpc":
            case "mpc":
                    finData = "mpc";
                break;
            case "drcentromater":
            case "centromater":
                finData = "centromater";
                break;
            case "drhubio":
            case "hubio":
                finData = "hubio";
                break;
            case "drschiller":
            case "schiller":
                finData = "schiller";
                break;
            default:
                break;
        }
    }
    const find = app ? environment.appsSubdomains[app][finData] : environment.appsSubdomains.saludProx[finData];
    return find;
}
export function getSubdomainCodeEmail (getSalud?:boolean) : codeApp {
    let code :codeApp = getSalud ? "SALUDPROX" : "DRPROX";
    const hostname = window.location.hostname;  
    const hostnameSplited = hostname.split(".");
    if (hostnameSplited.length > 0) {
        switch (hostnameSplited[0]) {
            case "drgyc":
            case "gyc":
                    code = getSalud ? "GYC_SP" : "GYC_DP";
                break;
            case "drmpc":
            case "mpc":
                    code =  getSalud ? "MPC_SP" : "MPC_DP";
                break;
            case "drcentromater":
            case "centromater":
                code =  getSalud ? "CM_SP" : "CM_DP";
                break;
            case "drhubio":
            case "hubio":
                code =  getSalud ? "HUBIO_SP" : "HUBIO_DP";
                break;
            case "drschiller":
            case "schiller":
                code =  getSalud ? "SCHILLER_SP" : "SCHILLER_DP";
                break;
            default:
                break;
        }
    }
    return code;
}